'use client';

import { createClient } from '@supabase/supabase-js';
import { env } from '@/lib/env';

/**
 * Lightweight Supabase client using implicit auth flow.
 *
 * Used ONLY for password reset emails. The standard @supabase/ssr client
 * uses PKCE, which stores a code_verifier in browser cookies. PKCE breaks
 * when the email link is opened:
 *   - On a different device (phone vs desktop)
 *   - In iOS Mail's in-app browser (separate cookie jar)
 *   - In any cross-browser scenario
 *
 * Implicit flow embeds tokens directly in the redirect URL hash fragment,
 * making password reset work regardless of where the link is opened.
 * This is the industry-standard approach for email-based recovery flows.
 */
let implicitClient: ReturnType<typeof createClient> | null = null;

export function getImplicitFlowClient() {
  if (implicitClient) return implicitClient;

  implicitClient = createClient(env.NEXT_PUBLIC_SUPABASE_URL, env.NEXT_PUBLIC_SUPABASE_ANON_KEY, {
    auth: {
      flowType: 'implicit',
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
    },
  });

  return implicitClient;
}
